interface FormLayoutProps {
  children: React.ReactNode;
}

export default function FormLayout({ children }: FormLayoutProps) {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-gray-100"
      style={{ backgroundColor: '#F4F6F9' }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-gray-300 opacity-50"
        style={{ backgroundColor: '#E7E7E7' }}
      ></div>

      {/* Main Dialog */}
      <div
        className="relative z-10 mx-4 w-full overflow-hidden rounded-3xl bg-white shadow-2xl"
        style={{
          maxWidth: '1100px',
          height: '728px',
          boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        {/* Background Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Right-top blur - Purple */}
          <div
            className="absolute rounded-full"
            style={{
              background: '#F6F3FF',
              width: '796.91px',
              height: '630.18px',
              left: '591.79px',
              top: '-193.38px',
              filter: 'blur(200px)',
            }}
          ></div>
          {/* Left-bottom blur - Blue */}
          <div
            className="absolute rounded-full"
            style={{
              background: '#EDF8FF',
              width: '517.38px',
              height: '409.13px',
              left: '-181.4px',
              top: '395.79px',
              filter: 'blur(200px)',
            }}
          ></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex h-full flex-col items-center px-24 py-[100px]">
          {children}
        </div>
      </div>
    </div>
  );
}
